export default __webpack_public_path__ + "static/media/digital.6ce18110.jpg";